import {
  EXPLAIN_PANEL_CLASS,
  EXPLAIN_SCROLL_CLASS,
  EXPLAIN_TAG_CLASS,
} from '../table-session/ExplainPanel';
import { renderCallTokens } from '../../utils/callTokensInText';
import { renderWithEditorNote } from '../../utils/editorNote';

/**
 * The problem's descriptive answer, in the frame's full-width row beneath the three panels
 * (feature 029).
 *
 * <p>That row is where the practice pages put Jeff's commentary, and this is the same shape of
 * content in the same place: a paragraph of expert prose about the auction above it. So it wears
 * the identical chrome — the brass-ruled notice box, the label pill, the capped scrolling column —
 * by importing those class strings rather than by copying them. Two of the names in them are CSS
 * hooks and not decoration: `explain-panel` is how index.css sizes the box on height-starved
 * viewports, and `explain-comment-scroll` is one of exactly two elements the page's no-scrollbar
 * contract permits to scroll, with a three-line floor beneath which it may not shrink.</p>
 *
 * <p>What it does NOT borrow is the live region. Jeff's commentary is feedback that ARRIVES when a
 * learner answers, so it announces itself; this answer is simply part of the problem, on screen
 * from first paint (FR-010), and announcing it on every step would talk over the editor.</p>
 */
export function ConceptualAnswerPanel({ answer }: { answer: string | null }) {
  return (
    <div className={EXPLAIN_PANEL_CLASS} data-testid="conceptual-answer-panel">
      {/* Sentence case in the source, capitalised by CSS above the phone breakpoint — the
          constitution's rule governs the RENDERED word, so "ANSWER" typed here would break it. */}
      <span className={EXPLAIN_TAG_CLASS} data-testid="conceptual-answer-tag">
        Answer
      </span>
      <div className={EXPLAIN_SCROLL_CLASS}>
        {/* `whitespace-pre-line` keeps the editors' own paragraph breaks, which several of the
            longer answers rely on to separate a rule from its exceptions. */}
        <p className="whitespace-pre-line break-words" data-testid="conceptual-answer">
          {answer ? renderWithEditorNote(answer, renderCallTokens) : <span className="text-ink-soft">No answer recorded.</span>}
        </p>
      </div>
    </div>
  );
}
